import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsTreeMap from 'highcharts/modules/treemap';
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
import Boost from 'highcharts/modules/boost';

HighchartsMore(Highcharts);
HighchartsTreeMap(Highcharts);
Boost(Highcharts);
HighchartsSolidGauge(Highcharts);

Highcharts.setOptions({
  lang: {
    decimalPoint: '.',
    thousandsSep: ',',
  },
});

/**
 * @deprecated Use OPL Chart.tsx component instead.
 * thanks <3
 */
export default props => <HighchartsReact highcharts={Highcharts} {...props} />;
